import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Buque {
  static adaptToBackendUpdate (datosBuque = {}) {
    const {
      nombreCorto,
      nombre,
      pais,
      eslora,
      manga,
      puntal,
      calado,
      pesoBruto,
      pesoDeDesplazamiento,
      velocidadMaxima,
      velocidadMedia,
      atis,
      mmsi,
      imo
    } = datosBuque

    return {
      nombreCorto: nombreCorto,
      nombre: nombre,
      bandera: pais,
      eslora: eslora || null,
      manga: manga || null,
      puntal: puntal || null,
      calado: calado || null,
      pesoBruto: pesoBruto || null,
      pesoDeDesplazamiento: pesoDeDesplazamiento || null,
      velocidadMaxima: velocidadMaxima || null,
      velocidadMedia: velocidadMedia || null,
      atis: atis || null,
      mmsi: mmsi || null,
      imo: imo || null
    }
  }

  static async getDatosBuque (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/buque?r=` +
    `{"clave":{"nombre_corto":"${nombre}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static async insertBuque (buqueValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendUpdate(buqueValues)
    const promise = axios.post(`buque`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static async getNombreCorto (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/buque?r=` +
    `{"clave":{"nombre":"${nombre}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static getBuques () {
    const axios = getAxiosInstance()
    const promise = axios.get(`buque_listado?r=` +
    `{"orden": ["nombre_corto"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static updateBuque (datosBuque) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendUpdate(datosBuque)
    const promise = axios.put(`buque`, { valores: { ...valores }, clave: { nombre_corto: datosBuque.nombreCortoInicial } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static getEstadosBuque () {
    const axios = getAxiosInstance()
    const promise = axios.get(`estado_buque`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static obtenerBodegasBuque (buque) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["nombre"]'
    const promise = axios.get(`/bodega_ingreso_buque?r={"clave":{"buque": "${buque}"}, ${orden}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static insertarBodegaBuque (buque, bodega) {
    const axios = getAxiosInstance()
    console.log('buque y bodega ', buque, bodega)

    const nombreBodega = `BODEGA${bodega}`
    const promise = axios.post(`bodega_ingreso`, `{"valores": {"buque":"${buque}", "nombre": "${nombreBodega}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static deleteBodegaBuque (buque, bodega) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`bodega_ingreso?r=` +
    `{"clave": {"buque":"${buque}", "nombre": "${bodega}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default Buque
